import { isRouteErrorResponse } from "react-router";

import { AppBar } from "~/components/AppBar";
import { AppFooter } from "~/components/AppFooter";
import { AppLayout } from "~/components/AppLayout/AppLayout";
import { ErrorBoundary as AppErrorBoundary } from "~/components/ErrorBoundary";
import { NotFoundPage } from "~/components/NotFoundPage";
import { GlobalMetricsLine } from "~/feature/globalMetrics/components/GlobalMetricsLine";
import { loadMetrics } from "~/feature/globalMetrics/components/GlobalMetricsLine/globalMetricsLineApi";
import { useIsFullPageArchive } from "~/feature/pages/hooks/useIsFullPageArchive";
import { useIsSiteHeaderHidden } from "~/feature/pages/hooks/useIsSiteHeaderHidden";
import { loadFooterLinks } from "~/loaders/footerLinks";

import type { Route } from "./+types/layout";

export async function loader() {
  const [{ data }, footerLinks] = await Promise.all([
    loadMetrics(),
    loadFooterLinks(),
  ]);

  return { metrics: data, footerLinks };
}

export default function Layout({ loaderData }: Route.ComponentProps) {
  const hideSiteHeader = useIsSiteHeaderHidden();
  const isFullPageArchive = useIsFullPageArchive();

  return (
    <AppLayout
      metricsLine={
        isFullPageArchive ? null : <GlobalMetricsLine data={loaderData.metrics} />
      }
      appBar={hideSiteHeader ? null : <AppBar />}
      footer={
        isFullPageArchive ? null : <AppFooter cmsLinks={loaderData.footerLinks} />
      }
    />
  );
}

export function ErrorBoundary(props: Route.ErrorBoundaryProps) {
  if (isRouteErrorResponse(props.error) && props.error.status === 404) {
    return <NotFoundPage />;
  }

  return <AppErrorBoundary error={props.error} />;
}
